module.exports = __webpack_public_path__ + "media/images/about-wct-8400db8cb253ed1b51e5b1e0489ec374.jpg";